module.exports = __webpack_public_path__ + "static/media/synth_13.05ddeb8d.mp3";